import styles from './ActivateExcel.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import useLongTask from "../../Util/LongTaskItem/UseLongTask";
import TableItem from "../../FormTemplate/TableItem/TableItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
export default function ActivateExcel(){

    const [fileSelected, setFileSelected] = useState(false)
    const data = useRef(new FormData())
    const [ldrXlsFile,rsXlsFile,exXlsFile] = useApiQuery("/excel/upload","file",data);
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const [actList, setActList] = useState<any>([])


    const simActivateData = useRef({
        filePath:"",
    })
    const [ldrSimActivateData,rsSimActivateData,exSimActivateData] = useApiQuery("/api/application/sim/activate/excel","post",simActivateData);


    const [ldrSimActivateTask, exSimActivateTask] = useLongTask(100,5000, (state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),true)

    const [mode,setMode] = useState(0)

    const onResultTaskTick = (state:boolean, data:any, code:number,cnt:number)=>{
        if(Array.isArray(data))
        {
            setActList(data)
        }
        if(data?.errorAsString && errorLineRef.current) //Ловим catch на сервере в longtask
        {
            errorLineRef.current.show(data?.errorAsString,true,0)
            return;
        }
        if(state && errorLineRef.current)
        {
            errorLineRef.current.show("Задача выполнена",false,5000)
            return
        }

    }
    const handleFile = (e :React.ChangeEvent<HTMLInputElement>) =>{
        data.current.delete("file")
        if(! e.target.files)
        {
            setFileSelected(false)
            return
        }
        if(e.target.files.length > 0 )setFileSelected(true)
        else setFileSelected(false)
        console.log(e.target.files[0])
        data.current.append("file",e.target.files[0])
    }


    const handleLoad = () =>{
        if(errorLineRef.current)errorLineRef.current.clear()
        setActList([])
        if(!fileSelected)
        {
            if(errorLineRef.current !== null)errorLineRef.current.show("Файл не выбран",true,2000)
            return
        }
        exXlsFile().then((e)=>{
            if(e?.success !== undefined && e.success && e?.payload)
            {
                console.log("payload",e?.payload)
                simActivateData.current.filePath = e?.payload

                exSimActivateData().then((e)=>{
                    if(e?.success )
                    {
                        //checkTaskResult(e?.payload)

                        exSimActivateTask(e?.payload)

                        setMode(1)
                        return

                    }
                    if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка выполнения задачи" ,true,2000)
                }).catch((e)=>{
                    console.log(e)
                    if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,2000)
                })
                return

            }
            if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки файла" ,true,2000)
        }).catch((e)=>{
            if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,2000)
        })



    }


    return(
        <div className={styles.mainCont} >
            <MainFormTemplate title={"Активация по списку"} maxWidth={"600px"}>
                <div className={"row mb-3"}>
                    <div className={"cols-sm-12"}>
                        <input type="file" className="form-control" accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                               onChange={(e)=>handleFile(e)}
                        >
                        </input>
                    </div>

                </div>
                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>

                <div className={"row"}>
                    <div className={"col-sm-2 d-flex align-self-center"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={()=>handleLoad()}
                                    disabled={ldrSimActivateTask || ldrSimActivateData}
                            >Активировать</button>
                            <WaitLoader loading={ldrSimActivateTask || ldrSimActivateData} api={rsSimActivateData} onlyLoading={true}>

                            </WaitLoader>


                        </div>
                    </div>
                </div>
            </MainFormTemplate>
            <TableItem
                data={actList}
                onPageCount={50}
                column={[
                    {
                        type: 0,
                        maxLen: 40,
                        fieldId:"ctn",
                        title: "ctn",
                        mode: "sf",
                    },
                    {
                        type: 0,
                        maxLen: 40,
                        fieldId:"oper",
                        title: "Оператор",
                        mode: "sf",
                    },
                    {
                        type: 5,
                        maxLen: 40,
                        fieldId:"state",
                        title: "Зарег",
                        mode: "",
                    },
                    {
                        type: 0,
                        maxLen: 150,
                        fieldId:"ms",
                        title: "Сообщение",
                        mode: "s",
                    },

                ]}
            ></TableItem>


        </div>
    )
}